"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "connectAutoComplete", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectAutoComplete;
  }
});
Object.defineProperty(exports, "connectBreadcrumb", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectBreadcrumb;
  }
});
Object.defineProperty(exports, "connectConfigure", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectConfigure;
  }
});
Object.defineProperty(exports, "connectCurrentRefinements", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectCurrentRefinements;
  }
});
Object.defineProperty(exports, "connectGeoSearch", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectGeoSearch;
  }
});
Object.defineProperty(exports, "connectHierarchicalMenu", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectHierarchicalMenu;
  }
});
Object.defineProperty(exports, "connectHighlight", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectHighlight;
  }
});
Object.defineProperty(exports, "connectHitInsights", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectHitInsights;
  }
});
Object.defineProperty(exports, "connectHits", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectHits;
  }
});
Object.defineProperty(exports, "connectHitsPerPage", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectHitsPerPage;
  }
});
Object.defineProperty(exports, "connectInfiniteHits", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectInfiniteHits;
  }
});
Object.defineProperty(exports, "connectMenu", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectMenu;
  }
});
Object.defineProperty(exports, "connectNumericMenu", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectNumericMenu;
  }
});
Object.defineProperty(exports, "connectPagination", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectPagination;
  }
});
Object.defineProperty(exports, "connectPoweredBy", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectPoweredBy;
  }
});
Object.defineProperty(exports, "connectRange", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectRange;
  }
});
Object.defineProperty(exports, "connectRefinementList", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectRefinementList;
  }
});
Object.defineProperty(exports, "connectScrollTo", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectScrollTo;
  }
});
Object.defineProperty(exports, "connectSearchBox", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectSearchBox;
  }
});
Object.defineProperty(exports, "connectSortBy", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectSortBy;
  }
});
Object.defineProperty(exports, "connectStateResults", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectStateResults;
  }
});
Object.defineProperty(exports, "connectStats", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectStats;
  }
});
Object.defineProperty(exports, "connectToggleRefinement", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectToggleRefinement;
  }
});

var _reactInstantsearchCore = require("react-instantsearch-core");